// extracted by mini-css-extract-plugin
export default {"wrapper":"notAuthorized_wrapper__RzVfv","message-wrapper":"notAuthorized_message-wrapper__nZqxi","icon":"notAuthorized_icon__yd5rd","message":"notAuthorized_message__Mvudh"};